import './index.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import logo from '../../../../assets/images/logo/logo.svg';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="content-footer footer bg-footer-theme">
      <div className="container-xxl">
        <div className="footer-container d-flex align-items-center justify-content-between py-2 flex-md-row flex-column">
          © 2024, {t('CORE:made_with')} ❤️ &nbsp;{t('CORE:by')}&nbsp;
          <a href="https://matbao.ws" target="_blank">
            <figure
              style={{
                width: '82px',
                marginLeft: '4px',
              }}
            >
              <img
                src={logo}
                style={{
                  width: '100%',
                  height: '100%',
                }}
                alt="logo"
              />
            </figure>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
